import { type I18nLocale, t } from '@ardoq/i18n';
import { Texts } from './types';

export const getDefaultTexts = (i18nLocale: I18nLocale): Texts => ({
  noAvailableTable: t(
    i18nLocale,
    'integrations:fieldSelector.noAvailableTable',
    'No tables available yet'
  ),
  subtitle: '',
  searchPlaceholder: t(
    i18nLocale,
    'integrations:fieldSelector.searchPlaceholder',
    'Search for fields'
  ),
  noTableTitle: t(
    i18nLocale,
    'integrations:fieldSelector.noTableTitle',
    'No table selected'
  ),
  noTableSubtitle: t(
    i18nLocale,
    'integrations:fieldSelector.noTableSubtitle',
    'Select a table to view the fields'
  ),
  labelColumnTitle: t(
    i18nLocale,
    'integrations:fieldSelector.labelColumnTitle',
    'Field name'
  ),
  idColumnTitle: t(
    i18nLocale,
    'integrations:fieldSelector.idColumnTitle',
    'ID'
  ),
  availableTitle: t(
    i18nLocale,
    'integrations:fieldSelector.availableTitle',
    'Available fields'
  ),
  selectedTitle: t(
    i18nLocale,
    'integrations:fieldSelector.selectedTitle',
    'Selected fields'
  ),
});
